import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
  useTranslation
} from 'cng-web-lib'
import TermsAndConditionsKeys from 'src/constants/locale/key/TermsAndConditions'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  let errMsgMaxLength = translate(
    Namespace.TERMS_AND_CONDITIONS,
    TermsAndConditionsKeys.Validations.ERROR_MSG_MAX_LENGTH
  )

  return Yup.object({
    content: Yup.string().required(requiredMessage).max(100000,errMsgMaxLength + " 100000"),
    active: Yup.string(),
    versionNumber: Yup.string().required(requiredMessage),
  })
}

export default makeValidationSchema
